module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-Bold-a79073a0931599b03e3861acaf5ecff9.ttf";